import { Messages } from '../../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../../datasource/models/IDataSourceInfo';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDecryptAction } from '../../../../ts/ServerApi/types/actionNames';
import { encryptContent, EncryptionActionType } from '../../../actions/spaces/EncryptContentAction';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isVisibleOnEncryptionAction } from './IEntityActionHelpers';

export const DecryptAction: IEntityAction<IContentInfo, IDecryptAction> = {
  name: EntityActionNames.Decrypt,
  translateName: Messages.decrypt_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isVisibleOnEncryptionAction(targetItems as IDataSourceDetailInfo[], state);
  },
  isClickable: (availableActions: IDecryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.decryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.decryptExtracts)
};
